import MenuService from 'live/services/menu'
import ServiceLocator from 'live/services/service-locator'
import { LiveApi } from 'live/lib/api'
import Router from 'live/services/router'
import {StackStatus} from "./pages/stackStatus";
import ConfigStackInfo from "./pages/ConfigStackInfo"
import {canManageStacks, canViewStacks} from "../utils/permission";

const STACK = 'stack-overview'

Router.route('stack-overview', StackStatus, 'stack-overview')

Router.route('config/config-stack-overview', ConfigStackInfo, 'config-stack-overview')

if(canViewStacks()) {
    if (canManageStacks()) {

        LiveApi.Extension.configuration.entries.register({
            name: 'Stack Status Configuration',
            area: 'bdo',
            url: '/#/config/config-stack-overview',
            group: 'static-data',
            order: 2,
            routeUrl: 'config-stack-overview',
            component: ConfigStackInfo,
            permissions: [],
            config: {
                showOnMobile: false
            }
        })

    }

    const menuItem = {
        alias: STACK,
        selectedAliases: [STACK],
        name: 'Stack overview',
        order: 0.5,
        addRoute: true,
        // url: `/#/${ASSET_TYPE}`,
        url: `/#/stack-overview`,
        config: {
            showOnMobile: true
        }
    }

    MenuService.register(menuItem, 'regular')

    // ServiceLocator.getService('asset-service').then(AssetService =>
    //     AssetService.types.register({
    //         name: STACK
    //     })
    // )
}
